import { Logger } from "../../utils/logger"

const browserNameMap = {
  MicroMessenger: "MicroMessenger",
  MetaSr: "MetaSr",
  "QQ(Browser)?": "QQBrowser",
  UCBrowser: "UCBrowser",
  "2345Explorer": "2345Explorer",
  Mb2345Browser: "Mb2345Browser",
  Trident: "Internet Explorer",
  "Edge?": "Edge",
  OPR: "Opera",
  Vivaldi: "Vivaldi",
  Firefox: "Firefox",
  Chrome: "Chrome",
  Safari: "Safari",
}

function getNavigator() {
  if (!window) {
    throw "window is not defined"
  }
  if (!window.navigator) {
    throw "window.navigator is not defined"
  }
  const userAgent = navigator.userAgent

  return userAgent
}

export function getBrowserInfo(): string {
  const userAgent = getNavigator()
  const regexps = Object.keys(browserNameMap).map(
    (name) => new RegExp(`${name}(\\/|\\s)(\\d+\\.)+\\d+`)
  )
  const browsers = userAgent.match(/[a-z\d]+(\/|\s)(\d+\.)+\d+/gi) || []
  let browser = browsers.filter(
    (_) => regexps?.findIndex((v) => v.test(_)) !== -1
  )

  browser =
    browser.length > 1 && !/^Safari/.test(browser[browser.length - 1])
      ? browser.reverse()
      : browser
  const [str] = browser
  try {
    const ieVersionMap: { [key: string]: number | string } = {
      "4.0": 8,
      "5.0": 9,
      "6.0": 10,
      "7.0": 11,
    }
    // let engineType = 'WebKit'
    // if (userAgent.indexOf('Trident') !== -1) engineType = 'Trident'
    // if (userAgent.indexOf('Firefox') !== -1) engineType = 'Gecko'
    // if (userAgent.indexOf('Presto') !== -1) engineType = 'Presto'
    const { name, version } =
      // @ts-ignore
      str.match(/(?<name>[a-z\d]+)(\/|\s)(?<version>(\d+\.)+\d+)/i)?.groups ??
      {}

    let browserName = ""
    for (const [key, value] of Object.entries(browserNameMap)) {
      if (new RegExp(key).test(name)) {
        browserName = value
        break
      }
    }
    const result = {
      version: version ?? "unknow",
      browser: browserName ?? "unknow",
    }

    if (name === "Trident") {
      result.version = String(ieVersionMap[version])
    }
    return `${result.browser}: ${result.version}`
  } catch (error) {
    return "unknow"
  }
}

export function getSystemInfo() {
  const userAgent = getNavigator()
  const [, $1] =
    userAgent.match(/^[a-z]+\/\d+\.\d+\s?\(([a-z\d\s:;./_-]+)\)/i) || []
  let [platform, osVersion] = ["", ""]
  try {
    if (/Windows/i.test($1)) {
      const [, _osVersion] = $1.match(/NT\s(\d+\.\d+)/) || []
      platform = "Windows"
      switch (_osVersion) {
        case "6.3":
          osVersion = "8.1"
          break
        case "6.2":
          osVersion = "8"
          break
        case "6.1":
          osVersion = "7"
          break
        case "5.2":
        case "5.1":
          osVersion = "XP"
          break
        default:
          osVersion = _osVersion
      }
      osVersion = osVersion
    } else if (/^Macintosh/i.test($1)) {
      [, osVersion] = $1.match(/X\s((\d+(_|\.))+\d+)/) || []
      platform = "Macintosh"
      osVersion = osVersion?.replace(/_/g, ".") ?? "unkown"
    } else if (/^iPad/i.test($1)) {
      [, osVersion] = $1.match(/((\d+_)+\d+)/) || []
      platform = "iPad"
      osVersion = osVersion.replace(/_/g, ".")
    } else if (/^iPhone/i.test($1)) {
      [, osVersion] = $1.match(/((\d+_)+\d+)/) || []
      platform = "iPhone"
      osVersion = osVersion.replace(/_/g, ".")
    } else if ($1.indexOf("Android") !== -1) {
      let [, _version] = $1.match(/Android\s((\d+\.?)+\d?)/) || []
      platform = "Android"
      osVersion = _version
    } else if (/Linux\s[a-z\d_]+/.test($1)) {
      platform = "Linux"
      osVersion = "unkown"
    }
  } catch (error) {
    platform = "unkown"
    osVersion = "unkown"
  }
  return `${platform}: ${osVersion}`
}

/**
 * 全局信息
 * 缓存 init DSL 中构建侧传入的信息
 */
type infoKeys = {
  // 登录配置
  login?: Tlogin
  __isAppWorker__?: boolean
  // 浮层配置
  overlayConfigs?: any[]
  // 灰度配置
  grayConfig?: TgrayConfig
  // 腾黄配置
  todhornInfo?: TtodhornInfo
} & AppInfo
let _info: infoKeys = {} as infoKeys
export const globalInfo = {
  init(info: AppInfo) {
    _info = Object.assign(_info, info)
  },
  set<K extends keyof infoKeys>(key: K, value: infoKeys[K]) {
    _info[key] = value
  },
  get<K extends keyof infoKeys>(key: K): infoKeys[K] {
    if (!(key in _info)) Logger.log(`get info ${String(key)} fail`, JSON.stringify(_info))
    return _info[key]
  },
}
